
import {DashboardRounded} from "@mui/icons-material";


import MembersForm from "../pages/contactForm";
import MembersForm2 from "../pages/forms/MembersForm";
import SelectForm from "../pages/SelectForm";

export const routes = [

    {
        name: 'Form Contacts IURD',
        path: '/app/contact',
        component: MembersForm,
    },

    {
        name: 'Form Contacts IURD',
        path: '/app/contact2',
        component: MembersForm2,
    },

    {
        name: 'Select Form',
        path: '/app',
        component: SelectForm,
    },
    
];